import { api } from '@/lib/api';
import type { IApiResponse, IOrphanedStory, IQualityControlFilterOptions, IQualityControlOverview } from '@skystone/shared';

export interface QualityControlQueryParams {
  region?: string;
  productId?: string;
  teamId?: string;
}

function buildQuery(params?: QualityControlQueryParams): string {
  const search = new URLSearchParams();
  if (params?.region) search.set('region', params.region);
  if (params?.productId) search.set('productId', params.productId);
  if (params?.teamId) search.set('teamId', params.teamId);
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export const qualityControlApi = {
  getOrphanedStories: async (params?: QualityControlQueryParams): Promise<IOrphanedStory[]> => {
    const result = await api.get<IApiResponse<IOrphanedStory[]>>(
      `/quality-control/orphaned-stories${buildQuery(params)}`,
    );
    return result.data;
  },

  getOverview: async (params?: QualityControlQueryParams): Promise<IQualityControlOverview> => {
    const result = await api.get<IApiResponse<IQualityControlOverview>>(
      `/quality-control/overview${buildQuery(params)}`,
    );
    return result.data;
  },

  getFilterOptions: async (): Promise<IQualityControlFilterOptions> => {
    const result = await api.get<IApiResponse<IQualityControlFilterOptions>>(
      '/quality-control/filter-options',
    );
    return result.data;
  },
};
